import { getStyle } from '@touchvue/utils'
import { ToMsg } from '@touchvue/components'
import { h, nextTick, render } from 'vue'

const vLoadingDirective = {
	mounted(el: HTMLElement, binding: { value: any }) {
		if (binding.value) {
			el.classList.add('to-loading')
		}
		const elPositon = getStyle(el, 'position')
		if (!elPositon || elPositon === 'static') {
			el.style.position = 'relative'
		}

		const vnode = h(ToMsg, {
			type: 'loading',
			zIndex: Number(el.getAttribute('to-loading-z-index')) || 0,
			title: el.getAttribute('to-loading-title') || '',
			content: el.getAttribute('to-loading-content') || '',
			global: false,
			confirmable: false,
			cancelable: false,
			closeOnBlur: false
		})
		if (ToMsg._context) {
			vnode.appContext = ToMsg._context._context
		}
		render(vnode, el)
		nextTick(() => {
			const component = vnode.component
			if (binding.value) {
				component?.exposed?.open()
			} else {
				component?.exposed?.close()
			}
			el['_loading'] = component
		})
	},
	updated(el: HTMLElement, binding: { value: any }) {
		let timer = null
		timer = setTimeout(() => {
			el['_loading'].props.title = el.getAttribute('to-loading-title') || ''
			el['_loading'].props.content = el.getAttribute('to-loading-content') || ''
			if (binding.value) {
				el['_loading'].exposed?.open()
			} else {
				el['_loading'].exposed?.close()
			}
			clearTimeout(timer)
			timer = null
		}, 0)
	},
	unmounted(el: HTMLElement, _binding: any) {
		if (el && el['_loading']) {
			el['_loading'].exposed?.close()
			render(null, el)
			el['_loading'] = null
		}
	}
}

export default vLoadingDirective
